import createModule from "../createModule"
import { getAccountsDetails, getName, getRedirectUrl, getIsSuperuser, getPartnersDetails } from "./selectors"
import view from "./view"

export default createModule({
  view,
  data: [{
    resource: "accounts",
    as: null,
    noToken: true,
    url: () => "/api/users/me/accounts",
  },
  {
    resource: "partners",
    as: null,
    noToken: true,
    url: () => "/api/users/me/partners",
  }],
  mapStateToProps: (state, props) => ({
    accountsDetails: getAccountsDetails(state, props),
    name: getName(state),
    redirect: getRedirectUrl(state, props),
    isSuperuser: getIsSuperuser(state),
    partnersDetails: getPartnersDetails(state, props),
  }),
})
